import store from "%root/store";

import { PUSH_NOTIFICATION } from ":mutations";

export function pushNotification(component, props) {
  store.commit(PUSH_NOTIFICATION, { component, props });
}
